let _this;
import tagsCheck from '../commonComponents/tagsCheck.vue'
import scheduleSetting from '../commonComponents/scheduleSettingModal.vue'
import accessCodeDetail from '.././staffManagement/accessCodeDetail.vue'
import userPrint from '../commonComponents/userPrinting.vue'
import scheduleDetails from '../commonComponents/scheduleDetailsModal.vue'

export default {
  name: "edit-vehicle",
  components:{tagsCheck,scheduleSetting,accessCodeDetail,userPrint,scheduleDetails},
  data(){
    _this = this;
    return{
      vehicleInfo:{
        targetNodeId:'',
        officeId:'',
        platePrefixType: 0,
        plateNumber: '',
        vehicleType: '',
        parkingType : 0,
        driverType: 0,
        tagIds:[],
        validityType:0,
        validityStartTime:  _this.common.formatDate(_this.moment(), _this.$root.Time[_this.$root.Time.type].typeDateHM),
        validityEndTime:'',
        enableState:true,
        attachments:[],
      },

      isNeedAttachment: this.ApiService.vehicleSettingInfo.enableAttachment,
      userACData:[],
      acTitleData:[
        {
          title: _this.ApiService.accessCodeName,
          slot: 'accessCodeName',
          minWidth: 150,
        },{
          title: 'Source',
          key: 'source',
          minWidth: 150,
        },
        {
          title: 'Validity',
          slot:'validity',
          minWidth: 320,
        },{
          title: 'Operator',
          key: 'operatorName',
          minWidth: 150,
        },{
          title: 'Last Update',
          slot:'lastUpdateTime',
          minWidth: 150,
        },{
          title: 'Status',
          slot:"enableState",
          minWidth: 150,
        },{
          title: 'Operation',
          slot: 'operation',
          width: 150,
          align: 'left',
          fixed: 'right',
        },
      ],
      validityFlag:false,
      idSearchModal:false,
      viewBasicInfo:{tagArray:[]},
      sameIdList:[],/*共同ID集合*/
      cardTagIds:[],/*卡tagid*/
      vehicleId:"",
      acTabIndex:0,/*ac导航标签*/
      noACStr:"<div class='utm-table-nodata'><i class='utm-font utm-access-code'></i><p> No Data </p></div>",/*无AC时数据显示*/
      tempACInfo:{},
      accessZoneList:[],
      tempACValidityFlag:false,
      scheduleFlag:false,
      options1:{
        disabledDate(date) {
          return date.valueOf() <  new Date().getTime() - 86400000;
        }
      },
      departmentList:[],
      customFields:[],
      //  AC
      accessCodeName:"",
      editACFlag:false,
      userACInfo:{},
      accessCodeFlag:false,
      acValidityFlag:false,
      searchACTimer:'',
      accessCodeList:[],
      accessCodeModal:false,
      replaceTipModal:false,
      replaceInfo:{},
      scheduleList:[],
      moreTableData:[],/*schedule详情*/
      scheduleTitle:'',/*schedule详情标题*/
      policyList:[],
      userType: [],
      userList:[],
      typeFlag :false,
      modeFlag :false,
      allPolicyList:[],
      searchAC:{
        accessCodeName: '',
        tagIds:[],
      },
      acPage : 1,
      ACTagList:[],
      isSGLimit:false,
      costCentreList:[],
      /*下拉滚动查询Driver*/
      searchUser:{page:1},
      originalACValidity:{}, //ac原来的有效期
      timeZoneId:'',
      billingPolicyId:false,
      disabledMode:false,
    }
  },
  mounted(){
    _this = this;
    this.getScheduleList();
    this.getCostCentreList();
  },
  methods:{
    changeNode:function(){
      _this.$set(_this.vehicleInfo,'driverId',null);
      _this.$set(_this.vehicleInfo,'billingPolicyId','');
      _this.disabledMode = false;
      _this.getCustomFields();
      _this.getVehicleBillingPolicy();
      _this.getACList();
      _this.userACData = [];
      _this.ApiService.getAllConfigSetting(_this.vehicleInfo.targetNodeId);
      _this.$forceUpdate();
    },
    changeOffice(office){
      _this.timeZoneId = office.timeZoneId;
      _this.$set(_this.vehicleInfo,'driverId',null);
      _this.getUserList();
      _this.$forceUpdate();
    },
    getCostCentreList:function(){
      this.$ajax.post('VehicleCostCentre/QueryPaginate', { sortName: 'name', sortType: 0, enabledPaging: false}).then(res=>{
        if(res.data.data){
          _this.costCentreList = res.data.data.items;
        }else {
          _this.costCentreList = [];
        }
      })
    },
    policyManager:function(){
      if(_this.$root.adminInfo.permissionCodes.indexOf('M_AddBillingPolicy') == -1){
        return false
      }
      this.$router.push({path:"/billingPolicyInfo"});
      eventBus.$emit('closeVehicleRegistration');
    },
    changeDriverType:function(data){
      _this.$set(_this.vehicleInfo ,'driverType' ,data);
      _this.vehicleInfo.driverName = '';
      _this.vehicleInfo.driverId = null;
      _this.$forceUpdate();
    },
    getVehicleBillingPolicy:function(){
      let params = {
        buildingIds:this.$root.curNodeInfo.id === null ? [_this.vehicleInfo.targetNodeId] :[this.$root.curNodeInfo.id],
        parkModes:[_this.vehicleInfo.parkingType],
        sortType: 0,
        sortName: 'name',
        enabledPaging:false,
      }
      _this.$ajax.post('VehicleBillingPolicy/QueryPaginate',params).then(res=>{
        if(res.data.success){
          _this.policyList = []
          _this.allPolicyList = []
          let data = res.data.data.items;
          data.forEach(item=>{
            _this.policyList.push({name:item.name ,id :item.id ,vehicleTypes: item.vehicleTypes||[],status:item.status});
          })
          _this.allPolicyList = _this.policyList;
        }else {
          _this.policyList = [];
        }
      })
      _this.$set(_this.vehicleInfo,'billingPolicyId','');
      _this.disabledMode = false;
    },
    checkPolicy:function(data){
      _this.modeFlag = data.value === '' ? true : false;
      let curInfo = _this.allPolicyList.filter(it=>{return it.id == data.value})[0];
      if(curInfo){
        _this.disabledMode = curInfo.status == 1 ? true : false
      }else{
        _this.disabledMode = false
      }
      _this.$forceUpdate();
    },
    // 车牌号检索
    sameIdSearch:function (data) {
      setTimeout(() => {
        // 进行失焦后的处理
        this.$refs.inputField.blur();
      }, 100); // 延迟100毫秒处理失焦事件
      _this.sameIdList =  [];
      if(_this.vehicleInfo.plateNumber){
        this.$ajax.get('Vehicle/GetByPlateNumber?plateNumber='+_this.vehicleInfo.plateNumber + '&queryNodeId=' + _this.vehicleInfo.targetNodeId,{headers:{noLoading:true}}).then(function (res) {
          _this.sameIdList = []
          if(res.data.success ){
            let data = res.data.data
            if(data){
              _this.sameIdList.push(data);
            }else {
              _this.sameIdList =  [];
            }
            if(_this.sameIdList.length > 0){
              _this.idSearchModal = true;
            }
          }else{
            _this.messageNotice('error',res.data.message);
          }
        })
      }
    },
    checkPlateNumber:function(){
      if(_this.vehicleInfo.platePrefixType === 1) {
        let str = JSON.parse(JSON.stringify(_this.vehicleInfo.plateNumber))
        let str1 = str.substr(str.length-1,1)
        if(/^[a-zA-Z]*$/.test(str1)){
          _this.isSGLimit = false;
        }else {
          _this.isSGLimit = true;
        }
      }else {
        _this.isSGLimit = false;
      }
    },
    checkParkMode:function(type){
      if(type){
        _this.$set(_this.vehicleInfo , 'billingPolicyId', '')
        _this.disabledMode = false;
        _this.policyList = []
        _this.policyList = _this.allPolicyList.filter(item=>{
          return item.vehicleTypes.indexOf(type) > -1 || item.vehicleTypes.length === 0
        });
        _this.typeFlag = false;
      }else {
        _this.typeFlag = true;
      }
    },
    openIcPanel:function (e) {
      $(e.target).parents('.ic-control').find('.other-ics').slideDown(300);
    },
    // 展开相同内容
    expandContent:function (e) {
      $(e.target).parents('.details-box-option').find('.details-module-content').slideToggle(300);
      $(e.target).parents('.details-box-option').find('.ivu-icon-ios-arrow-up').toggleClass('rotate');
    },
    // 信息替换
    uploadInfo:function (user) {
      this.replaceInfo = user;
      let userUpdateInfo = this.vehicleInfo;
      userUpdateInfo.customFields = _this.customFields;
      userUpdateInfo.userACData = _this.userACData;
      localStorage.setItem('userUpdateInfo',JSON.stringify(userUpdateInfo));
      this.replaceTipModal = true;
    },
    // 确认替换
    confirmReplace:function () {
      _this.replaceTipModal = false;
      _this.$parent.registerVehicleModal = false;
      _this.$router.push({path:'/editVehicle',query:{vehicleId:this.replaceInfo.id,repFlag:true}});
    },
    // 获取自动AC
    getAutoAC:function (data) {
      if(_this.ApiService.isGetDepartmentAutoAC){
        _this.userACData = [];
        data.accessCodes.forEach(item =>{
          _this.userACData.push({
            accessCodeName:item.name,
            accessCodeId:item.id,
            source:item.source,
            validityStartTime:_this.vehicleInfo.validityType === 0 ? null : _this.common.formatDate(_this.vehicleInfo.validityStartTime,_this.$root.Time[_this.$root.Time.type].typeDateHM,2),
            validityEndTime:_this.vehicleInfo.validityType === 0 ? null : _this.common.formatDate(_this.vehicleInfo.validityEndTime,_this.$root.Time[_this.$root.Time.type].typeDateHM,2),
            enableState:0,
            lastUpdateTime:item.lastUpdateTime,
            viewStatus:_this.vehicleInfo.validityType === 0 ? 0 : _this.shareApi.getUserACStatus(_this.vehicleInfo,0,_this),
          })
        });
      }
    },
    // 时间对比
    dateCompared:function (flag,type,objStr,startAttr,endAttr) {
      _this.shareApi.userValidityCompare(flag, type, objStr, startAttr, endAttr,_this,'vehicleInfo');
    },
    getCheckedTags:function (data){
      this.viewBasicInfo.tagArray = data;
    },

    /*user滚动加载*/
    searchNow:function(){
      this.$refs.cardSelect.visible = true;
      clearTimeout(this.searchUser.timer);
      this.searchUser.page = 1;
      _this.getUserList(_this.userType);
    },
    //driver的搜索词变化
    changeQuery:function(value){
      this.searchUser.name = value;
      clearTimeout(this.searchUser.timer);
      this.searchUser.timer = setTimeout(function(){
        _this.searchUser.page = 1;
        _this.getUserList(_this.userType,value);
      },1000);
    },
    /*滚动到底部加载下一页*/
    handScroll:function(){
      _this.getUserList(_this.userType);
    },
    getUserLists(type,name){
      _this.searchUser.page = 1;
      _this.getUserList(type,name);
    },
    getUserList:function(type,name){
      let userName = '';
      if(_this.vehicleInfo.driverId){
        userName = name.substring(0,name.indexOf('('))
      }else {
        userName = name || _this.searchUser.name;
      }
      let params = {
        enabledPaging:true,
        page:_this.searchUser.page,
        perPage:10,
        userTypes: ((type && type.length === 0) || type === undefined) ? [0,1,2,3] : _this.userType,
        keyword: userName,
        sortType: 0,
        sortName: 'name',
      };
      this.$ajax.post('User/PagingSimpleUser',params,{headers:{noLoading:true}, codes: ['M_User'],cancelToken:new this.$ajax.CancelToken(function executor(c) {
          _this.searchUser.cancelToken = c;
        })}).then(function (res) {
        if(res.data.success ){
          let data =  res.data.data.items;
          _this.searchUser.pageCount = res.data.data.pageCount;
          if(data && data.length>0){
            data.forEach(item=>{
              if(item.identities && item.identities.length){
                _this.$set(item,'idNo','('+ _this.common.icType[item.identities[0].type].label + '-' + item.identities[0].number +')');
              }
            })
          }
          // 滚动加载
          if(_this.searchUser.page > 1){
            _this.userList = _this.userList.concat(data);
          }else{
            _this.userList = data;
          }
        }else{
          _this.userList = [];
          _this.messageNotice('error',res.data.message);
        }
      })
    },
    // 获取下拉框显示信息
    getSelectTxt: function (data, type) {
      if(data){
        _this.viewBasicInfo[type] = data.label;
      }
    },
    /*************车辆AC************/
     // 获取AC列表
     getACList:function(){
      clearTimeout(this.searchACTimer);
      let params = {
        accessCodeName:_this.searchAC.accessCodeName,
        tagIds:_this.searchAC.tagIds,
        enabledPaging:false,
        sortType:0,
        sortName:'name',
        isTemp:false,
        types:[1],
        fileterByAccountRoleAc: true,
      };
      if( _this.$root.adminInfo.permissionCodes && _this.$root.adminInfo.permissionCodes.indexOf('M_ViewAccessCodeList') === -1 ){
        return;
      }
      this.searchACTimer = setTimeout(function () {
        _this.$ajax.post('AccessCode/Paging',params,{headers:{noLoading:true}}).then(function (res) {
          if(res.data.success){
            _this.accessCodeList = res.data.data.items;
            _this.judgeSelectAllAC();
          }else{
            if(res.data.message){
            _this.messageNotice('error', res.data.message);
          }
          }
        });
      },300);
    },
    // 查询tag列表
    getTagLists: function (name) {
      if( _this.$root.adminInfo.permissionCodes && _this.$root.adminInfo.permissionCodes.indexOf('M_TagManagement') === -1 ){
        return;
      }
      _this.shareApi.getTagOptions({enabledPaging: false,types:[2000],name:name},{headers:{noLoading:true}}).done(result => {
        _this.ACTagList = result
      })
    },
    // 新增AC
    addUserAC:function(){
      _this.getTagLists();
      this.acPage = 1;
      this.editACFlag = false;
      this.userACInfo = {
        accessCodeIds:[],
        viewList:[],
        validityStartTime:  _this.common.formatDate(_this.moment(), _this.$root.Time[_this.$root.Time.type].typeDateHM),
        validityEndTime:'',
        validityType:0
      };
      this.accessCodeFlag = false;
      this.acValidityFlag = false;
      this.accessCodeModal = true;
    },
    // 选择/取消所有AC
    checkAllACs:function () {
      let array1 = _this.accessCodeList.map(item => item.id);
      let set1 = new Set(array1);
      let set2 = new Set(_this.userACInfo.accessCodeIds);
      let set3 = new Set(_this.accessCodeList);
      let set4 = new Set(_this.userACInfo.viewList);
      if(_this.userACInfo.checkAllAC){
        _this.userACInfo.accessCodeIds = Array.from(new Set([...set1,...set2]));
        _this.userACInfo.viewList = Array.from(new Set([...set3,...set4]));
      }else{
        _this.userACInfo.accessCodeIds = Array.from(new Set([...set2].filter(x => !set1.has(x))));
        _this.userACInfo.viewList = Array.from(new Set([...set4].filter(x => !set1.has(x.id))));
      }
      this.accessCodeFlag = false;
    },
    // 判断AC是否全选
    judgeSelectAllAC:function (){
      if(_this.userACInfo.accessCodeIds && _this.userACInfo.accessCodeIds.length > 0){
        _this.userACInfo.checkAllAC = _this.accessCodeList.every(item => _this.userACInfo.accessCodeIds.indexOf(item.id) > -1);
      }else{
        _this.userACInfo.checkAllAC = false;
      }
    },
    // 选择AC
    checkAC: function (data) {
      let index = _this.userACInfo.viewList.findIndex(item => data.id === item.id);
      if (index > -1) {
        _this.userACInfo.viewList.splice(index, 1);
      } else {
        _this.userACInfo.viewList.push(data);
      }
      _this.judgeSelectAllAC();
      _this.accessCodeFlag = false;
    },
    //删除AC
    deleteCode:function (code,index) {
      _this.userACInfo.viewList.splice(index,1);
      let index1 = _this.userACInfo.accessCodeIds.findIndex(id => code.id === id);
      _this.userACInfo.accessCodeIds.splice(index1,1);
      _this.userACInfo.checkAllAC = false;
    },
    // 修改AC信息
    modifyACInfo:function () {
      let flag = this.verifyAC();
      if(flag){
        let periodInfo = {
          validityStartTime:_this.userACInfo.validityStartTime || null,
          validityEndTime: _this.userACInfo.validityEndTime || null
        }
        _this.userACData[_this.userACInfo.index].validityStartTime = periodInfo.validityStartTime;
        _this.userACData[_this.userACInfo.index].validityEndTime = periodInfo.validityEndTime;
        _this.userACData[_this.userACInfo.index].viewStatus = _this.shareApi.getUserACStatus(periodInfo,periodInfo.enableState,_this);
        _this.userACInfo = {};
        _this.messageNotice('success');
        _this.accessCodeModal = false;
      }
    },
    // 验证AC
    verifyAC: function () {
      this.dateCompared(false,1,'userACInfo','validityStartTime','validityEndTime');
      if( (_this.userACInfo.validityType === 0 && !_this.userACInfo.validityStartTime) || (_this.userACInfo.validityType === 1 && (!_this.userACInfo.validityStartTime || !_this.userACInfo.validityEndTime)))  {
        _this.acValidityFlag = true;
      }
      if (!_this.editACFlag && _this.userACInfo.accessCodeIds.length === 0){
        _this.accessCodeFlag = true;
      }
      return !(_this.acValidityFlag || _this.accessCodeFlag);
    },
    // 编辑AC列表
    editAccessCode:function(data){
      this.editACFlag = true;
      this.userACInfo = {
        index:data._index,
        validityStartTime:  data.validityStartTime,
        validityEndTime:'',
        validityType:0
      };
      if(data.validityStartTime && data.validityEndTime){
        _this.userACInfo.validityType = 1;
        _this.userACInfo.validityStartTime = data.validityStartTime;
        _this.userACInfo.validityEndTime = data.validityEndTime;
      }
      _this.originalACValidity = JSON.parse(JSON.stringify(_this.userACInfo));
      this.accessCodeFlag = false;
      this.acValidityFlag = false;
      this.accessCodeModal = true;
    },
    // 删除AC
    deleteAC:function(index){
      _this.userACData.splice(index,1);
    },
    // 状态改变
    changeACStatus:function(data,index){
      _this.userACData[index].enableState = (data.enableState === 0 ? 1 : 0);
      _this.userACData[index].viewStatus =  _this.userACData[index].enableState;
    },
    // 保存AC
    saveACInfo:function () {
      let flag = this.verifyAC();
      if(flag){
        let periodInfo = {
          validityStartTime:_this.userACInfo.validityStartTime || null,
          validityEndTime: _this.userACInfo.validityEndTime || null
        }
        _this.userACInfo.viewList.forEach(item =>{
          _this.userACData.unshift({
            accessCodeName:item.name,
            accessCodeId:item.id,
            source:item.source,
            lastUpdateTime:_this.moment().valueOf(),
            validityStartTime:periodInfo.validityStartTime,
            validityEndTime:periodInfo.validityEndTime,
            enableState:0,
            operatorName:_this.$root.adminInfo.name,
            viewStatus:_this.shareApi.getUserACStatus(periodInfo,periodInfo.enableState,_this),
            serialNumber:item.serialNumber
          });
        });
        _this.userACInfo = {};
        _this.messageNotice('success',1);
        _this.accessCodeModal = false;
      }
    },
    /*************车辆AC************/

    // 保存信息
    saveVehicleInfo:function (){
      let subData = JSON.parse(JSON.stringify(_this.vehicleInfo));
      let array = _this.customFields.filter(item=>{
        return item.content !== ''
      })
      if(array.length > 0){
        subData.customizes = this.customFields.map(item =>{
          return {id:item.id,content:item.content}
        });
      }
      subData.disabled = !subData.enableState;
      if(subData.validityType === 0){
        subData.validityStartTime = _this.common.formatZoneDate(subData.validityStartTime, _this.$root.Time[_this.$root.Time.type].typeDateHM, 1);
        subData.isPermanent = true;   
        subData.validityEndTime = null;
      }else{
        subData.validityStartTime = _this.common.formatZoneDate(subData.validityStartTime, _this.$root.Time[_this.$root.Time.type].typeDateHM, 1);
        subData.validityEndTime = _this.common.formatZoneDate(subData.validityEndTime, _this.$root.Time[_this.$root.Time.type].typeDateHM, 1);
      }
      subData.accessCodes = [];
      _this.userACData.forEach(item =>{
        subData.accessCodes.push({
          "accessCodeId": item.accessCodeId,
          "startTime":  _this.common.formatZoneDate(item.validityStartTime, _this.$root.Time[_this.$root.Time.type].typeDateHM, 1),
          "endTime": item.validityEndTime == null ? null : _this.common.formatZoneDate(item.validityEndTime, _this.$root.Time[_this.$root.Time.type].typeDateHM, 1),
          "isPermanent": (item.validityEndTime == null && item.validityStartTime) ? true : false,
          "disabled": item.enableState !== 0,
        })
      });
      delete subData.driverType;
      delete subData.parkingType;
      delete subData.validityType;
      delete subData.enableState;
      delete subData.tags;
      delete subData.parkMode;
      delete subData.billingPolicyName;
      this.$ajax.post('Vehicle/Create',subData).then(function (res) {
        if(res.data.success){
          _this.messageNotice('success');
          eventBus.$emit('closeVehicleRegistration');
          _this.$router.push('/vehicleList');
        }else{
          _this.messageNotice('error',res.data.message);
        }
      })
    },
    // 表单验证
    applyInfo:function () {
      this.$validator.validateAll('vehicleInfo').then(result =>{
        _this.dateCompared(false,1,'vehicleInfo','validityStartTime','validityEndTime');
        if((_this.vehicleInfo.validityType === 0 && _this.vehicleInfo.validityStartTime === '') || (_this.vehicleInfo.validityType === 1 && (_this.vehicleInfo.validityStartTime === '' || _this.vehicleInfo.validityEndTime === ''))){           
          _this.validityFlag = true;
        }
        if(_this.vehicleInfo.vehicleType === ''){
          _this.typeFlag = true;
        }
        if(_this.vehicleInfo.billingPolicyId === ''){
          _this.modeFlag = true;
        }
        if(!(!result || _this.validityFlag || _this.typeFlag || _this.modeFlag || _this.isSGLimit)){
          _this.saveVehicleInfo();
        }
      });
    },
    // 卡状态切换
    changCardStatus:function () {
      let params = {
        id:_this.curCardInfo.cardId,
        status:(_this.curCardInfo.status === 0 ? 1:0)
      };
      this.$ajax.post('Card/UpdateStatus',params).then(function (res) {
        if(res.data.success){
          _this.messageNotice('success');
          _this.curCardInfo.status = (_this.curCardInfo.status === 0 ? 1:0);
          _this.getCardList();
        }else{
          _this.messageNotice('error',res.data.message);
        }
      })
    },
    /****************************附件上传******************************/
    handleUpload: function (file) {
      if(_this.vehicleInfo.attachments.length>=3){
        _this.messageNotice('error', "Support 'eml','msg','png','gif','jpeg','txt','pdf','xlsx','xls','docx','doc' format. Maximum 3 attachments allowed and each one should not exceed 3MB");
        return false;
      }
      if (file.size < 1024 * 1024 * 3) {
        let formatStr = file.name.substr(file.name.lastIndexOf(".")).toLowerCase();
        if (['.eml', '.msg', '.png', '.gif', '.jpeg', '.jpg', '.txt', '.pdf', '.xlsx', '.xls', '.docx', '.doc'].indexOf(formatStr) > -1) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function () {
            let imgBase64 = this.result.substring(this.result.indexOf('base64,') + 7, this.result.length);
            _this.vehicleInfo.attachments.push({'fileDataBase64': imgBase64, 'fileName': file.name,'fileSize':file.size});
          };
        } else {
          _this.messageNotice('error', "Support 'eml','msg','png','gif','jpeg','txt','pdf','xlsx','xls','docx','doc' format. Maximum 3 attachments allowed and each one should not exceed 3MB");
        }
      } else {
        _this.messageNotice('error', "Support 'eml','msg','png','gif','jpeg','txt','pdf','xlsx','xls','docx','doc' format. Maximum 3 attachments allowed and each one should not exceed 3MB");
      }
      return false;
    },
    // 删除附件
    deleteAttachment: function (index) {
      _this.vehicleInfo.attachments.splice(index, 1);
    },
    // 预览附件
    viewAttachment:function (file) {
      if(file.fileId){
        _this.shareApi.getFileContent(file);
      }else{
        const byteCharacters = atob(file.fileDataBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/octet-stream' });
        const a = document.createElement('a');
        a.download = file.fileName;
        a.href = URL.createObjectURL(blob);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
    /****************************附件上传******************************/
    // 获取自定义字段
    getCustomFields:function(){
      _this.$ajax.get('Customize/GetForVehicle').then(res=>{
        if(res.data.success){
          let result = res.data.data
          for(const item of result){
            _this.$set(item,"content","");
            _this.customFields.push(item);
          }
        }
      })
    },
    // 查询schedule
    getScheduleList:function () {
      if( _this.$root.adminInfo.permissionCodes && _this.$root.adminInfo.permissionCodes.indexOf('M_Schedule') === -1 ){
        return;
      }
      this.$ajax.post('Schedule/Paging',{enabledPaging: false,sortType:0,sortName:'name'}).then(function (res) {
        if(res.data.success){
          _this.scheduleList = res.data.data.items;
        }else{
          _this.messageNotice('error',res.data.message);
        }
      })
    },
    // 获取默认有效期
    getDefaultValidity: function () {
      this.acValidityFlag = false;
      if(this.editACFlag){
        if(_this.originalACValidity.validityType === 0){
          _this.userACInfo.validityStartTime = _this.userACInfo.validityType === 1 ? _this.common.formatDate(_this.moment(), _this.$root.Time[_this.$root.Time.type].typeDate) + ' 00:00' : _this.originalACValidity.validityStartTime;
          _this.userACInfo.validityEndTime = _this.userACInfo.validityType === 1 ? _this.common.formatDate(_this.moment(), _this.$root.Time[_this.$root.Time.type].typeDate) + ' 23:59' : null;
        }else{
          _this.userACInfo.validityStartTime = _this.originalACValidity.validityStartTime;
          _this.userACInfo.validityEndTime = _this.userACInfo.validityType === 1 ? _this.originalACValidity.validityEndTime : null;
        } 
      }else{
        _this.userACInfo.validityStartTime = _this.userACInfo.validityType === 1 ? _this.common.formatDate(_this.moment(), _this.$root.Time[_this.$root.Time.type].typeDate) + ' 00:00' : _this.common.formatDate(_this.moment(), _this.$root.Time[_this.$root.Time.type].typeDateHM);
        _this.userACInfo.validityEndTime = _this.userACInfo.validityType === 1 ? _this.common.formatDate(_this.moment(), _this.$root.Time[_this.$root.Time.type].typeDate) + ' 23:59' : null;
      }
     },
    // 数据替换
    replaceUserData:function () {
      if(_this.$route.query.repFlag){
        let oldInfo = JSON.parse(JSON.stringify(_this.vehicleInfo));
        oldInfo.customFields = JSON.parse(JSON.stringify(_this.customFields));
        oldInfo.userACData = JSON.parse(JSON.stringify(_this.userACData));
        oldInfo.tempAccessData = JSON.parse(JSON.stringify(_this.tempAccessData));
        let newInfo = JSON.parse(localStorage.getItem('userUpdateInfo'));
        let userData = _this.shareApi.userInfoIntegrate(oldInfo,newInfo);
        _this.vehicleInfo = userData.basicInfo;
        _this.customFields = userData.customFields;
        _this.userACData = userData.userACData;
        _this.tempAccessData = userData.tempAccessData;
      }
    },
    // 关闭弹框
    closeModal: function () {
      eventBus.$emit('closeVehicleRegistration');
    },
    //切换有效期模式
    changeVehiclePeriod(){
      this.validityFlag = false;
      _this.shareApi.getOperateStatus(_this,'vehicleInfo');
      this.shareApi.getValidityStartTime(_this,'vehicleInfo');
    }
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/fastRegistration/vehicleRegistration.js